import { cx } from "./cx";

/**
 * Discreet build-version stamp for the global footer: `v<semver> · <short sha>`
 * (e.g. `v0.2.0 · b012d58`). Reads NEXT_PUBLIC_APP_VERSION_LABEL, inlined at
 * build time (next.config.ts → buildVersionLabel), so it renders identically on
 * server and client. A pushed build can be matched to what's live by its SHA.
 * Renders nothing if the label is somehow absent (never breaks the footer).
 */
export function AppVersion({ className }: { className?: string }) {
  const label = process.env.NEXT_PUBLIC_APP_VERSION_LABEL;
  if (!label) return null;
  return (
    <span className={cx("pz-appversion", className)} aria-label={`Build ${label}`}>
      {label}
    </span>
  );
}
